import logo from './assets/img/logo.png';
//import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect, Component,/*, useCallback, Fragment, useCallback*/ } from "react";
import axios from 'axios';
import Accordion from 'react-bootstrap/Accordion';
import Dropdown from 'react-bootstrap/Dropdown';
import { settings } from './Helpers/Settings.js';
//import settings from './Settings.json';

import Home from './Pages/Genel/Home.js';
import Karekod from './Pages/Genel/Karekod.js';
import Cari from './Pages/ERP/Cari.js';
import Malzeme from './Pages/ERP/Malzeme.js';
import Proje from './Pages/ERP/Proje.js';
import UrunGrubu from './Pages/Tanim/UrunGrubu.js';
import UrunOlcusu from './Pages/Tanim/UrunOlcusu.js';
import MasrafTuru from './Pages/Tanim/MasrafTuru.js';
import MalzemeGrubu from './Pages/Tanim/MalzemeGrubu.js';
import Tanim from './Pages/Tanim/Tanim.js';
import Ayar from './Pages/Ayar/Ayar.js';
import Rol from './Pages/Ayar/Rol.js';
import Kullanici from './Pages/Ayar/Kullanici.js';
import Duyuru from './Pages/Ayar/Duyuru.js';
import Profil from './Pages/Ayar/Profil.js';
import ChangePassword from './Pages/Ayar/ChangePassword.js';
import Login from "./Pages/Auth/Login.js";
import ForgetPassword from "./Pages/Auth/ForgetPassword.js";
import ActivatePassword from "./Pages/Auth/ActivatePassword.js";
import MesajYaz from './Pages/Mesaj/MesajYaz.js';
import MesajAc from './Pages/Mesaj/MesajAc.js';
import MesajKutusu from './Pages/Mesaj/MesajKutusu.js';
import MesajGrubu from './Pages/Mesaj/MesajGrubu.js';
import { /*useJwt,*/ isExpired, decodeToken } from "react-jwt";
import { SetAuthToken } from './Exclude/SetAuthToken.js';
import { history } from "./Auth/history";
import { BrowserRouter, Route, Routes, NavLink } from 'react-router-dom';
import ProtectedRoute from './Auth/ProtectedRoute.js';
import AuthService from './Auth/AuthService.js';

import './assets/img/favicon.png'
import './assets/img/apple-touch-icon.png'

//import 'https://fonts.gstatic.com'
//import 'https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Nunito:300,300i,400,400i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i'

import './assets/vendor/bootstrap/css/bootstrap.min.css'
import './assets/vendor/bootstrap-icons/bootstrap-icons.css'
//import './assets/vendor/boxicons/css/boxicons.min.css'
//import './assets/vendor/quill/quill.snow.css'
//import './assets/vendor/quill/quill.bubble.css'
//import './assets/vendor/remixicon/remixicon.css'
//import './assets/vendor/simple-datatables/style.css'

import './assets/css/style.css'

//import "./assets/js/main3.js";

import './App.css';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';




function App() {
  const token = localStorage.getItem("accessToken");

  if (token) {
    SetAuthToken(token);
  } else {

  }

  const [dataBildirimSayisi, setDataBildirimSayisi] = useState(null);
  const [sumBildirimSayisi, setSumBildirimSayisi] = useState(0);
  const [sumGelenMesajSayisi, setSumGelenMesajSayisi] = useState(0);
  const [data, setData] = useState(null);
  const [toggleclassName, setToggleclassName] = useState('');
  const [isAuthPage, setIsAuthPage] = useState(0);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const location = window.location.pathname;

    setIsAuthPage(location === "/" || location.startsWith("/Auth") ? 1 : 0);
  });

  const getData = async () => {
    try {
      const token = localStorage.getItem('ATGroupToken');
      //const { decodedToken, isExpired } = useJwt(token);
      const decodedToken = decodeToken(token);
      const isTokenExpired = isExpired(token);

      if (isTokenExpired === false) {
        //const arrayToken = token.split('.');
        //const tokenPayload = JSON.parse(atob(arrayToken[1]));
        const userId = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];

        const resData = await axios.post(settings.ApiUrl + 'Login/GetKisiMenu/', userId, { headers: AuthService.getHeaders() })

        if (resData) {
          setData(resData.data.value);
        }

        const resBildirimSayisi = await axios.get(settings.ApiUrl + "Rol/GetBildirimSayisi", { headers: AuthService.getHeaders() });

        if (resBildirimSayisi) {
          let tempDataBildirimSayisi = resBildirimSayisi.data.value.filter(item => item.id !== -1);
          let tempDataGelenMesajSayisi = resBildirimSayisi.data.value.filter(item => item.id === -1);

          setDataBildirimSayisi(tempDataBildirimSayisi);

          let tempSumBildirimSayisi = tempDataBildirimSayisi.reduce((total, currentValue) => total = total + currentValue.basvuruSayisi, 0);

          setSumBildirimSayisi(tempSumBildirimSayisi);

          if (tempDataGelenMesajSayisi && tempDataGelenMesajSayisi.length > 0) {
            setSumGelenMesajSayisi(tempDataGelenMesajSayisi[0].basvuruSayisi);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const renderTooltip = (toolTipMessage, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {toolTipMessage}
    </Tooltip>
  );

  const handleToggleclassName = (e) => {
    setToggleclassName(toggleclassName === "" ? "toggle-sidebar" : "");
  }

  const Logout = () => {
    AuthService.logout();
  }

  return (
    <div className={toggleclassName}>

      <BrowserRouter History={history}>
        {
          isAuthPage ?
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/auth/forgetpassword' element={<ForgetPassword />} />
              <Route path='/auth/activatepassword' element={<ActivatePassword />} />
            </Routes>
            :
            <div>
              <header id="header" className="header fixed-top d-flex align-items-center">

                <div className="d-flex align-items-center justify-content-between">
                  <NavLink className="logo d-flex align-items-center" to="/home">
                    <span className="d-none d-lg-block"><img src={logo} alt="" width={216} height={56}></img></span>
                  </NavLink>
                  <i className="bi bi-list toggle-sidebar-btn" onClick={(e) => handleToggleclassName(e)}></i>
                </div>

                <nav className="header-nav ms-auto" style={{ display: "flex", alignItems: "anchor-center" }}>
                  {/* {
                    dataBildirimSayisi && dataBildirimSayisi.length > 0 ?
                      dataBildirimSayisi.map((bildirimSayisi, index) => {
                        return (
                          <OverlayTrigger key={index} placement="bottom" delay={{ show: 5, hide: 5 }} overlay={renderTooltip(bildirimSayisi.basvuruTipi)}>
                            <NavLink to={"/Genel/Basvuru/Bildirim" + bildirimSayisi.id}>
                              <div className='bildirim' style={{backgroundColor:"red"}}>
                                {bildirimSayisi.basvuruSayisi}
                              </div>
                            </NavLink>
                          </OverlayTrigger>
                        )
                      })
                      :
                      ''
                  } */}

                  <button id="btnBildirimYenile" onClick={() => getData()} style={{ visibility: "hidden" }}></button>

                  <Dropdown style={{ marginLeft: "40px" }}>
                    <Dropdown.Toggle variant="sm" drop="up" id="dropdown-basic" style={{ border: "none" }}>
                      <i className="bi bi-bell" style={{ fontSize: "1.4rem" }}></i>
                      {sumBildirimSayisi > 0 ? <span className="badge bg-danger badge-number">{sumBildirimSayisi}</span> : ""}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {
                        dataBildirimSayisi && dataBildirimSayisi.length > 0 ?
                          dataBildirimSayisi.map((bildirimSayisi, index) => {
                            return (
                              <Dropdown.Item key={index}>
                                <NavLink to={"/Genel/Basvuru/Bildirim" + bildirimSayisi.id}>
                                  <i className="bi bi-info-circle text-danger" style={{ paddingRight: "8px" }}></i>{bildirimSayisi.basvuruSayisi + " adet " + bildirimSayisi.basvuruTipi}
                                </NavLink>
                              </Dropdown.Item>
                            )
                          })
                          :
                          <Dropdown.Item>
                            Bildirim bulunamadı
                          </Dropdown.Item>
                      }
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown style={{ marginLeft: "24px" }}>
                    <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                      <i className="bi bi-chat-left-text" style={{ fontSize: "1.4rem" }}></i>
                      {sumGelenMesajSayisi > 0 ? <span className="badge bg-danger badge-number">{sumGelenMesajSayisi}</span> : ""}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <NavLink to="/Mesaj/MesajYaz">
                          <i className="bi bi-chat-square text-success" style={{ paddingRight: "8px" }}></i>Mesaj Yaz
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <NavLink to="/Mesaj/MesajKutusu/1">
                          <i className="bi bi-chat-right-text text-info" style={{ paddingRight: "8px" }}></i>Gelen Mesajlar
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <NavLink to="/Mesaj/MesajKutusu/2">
                          <i className="bi bi-chat-left-text text-info" style={{ paddingRight: "8px" }}></i>Giden Mesajlar
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <NavLink to="/Mesaj/MesajGrubu">
                          <i className="bi bi-chat-square-heart text-danger" style={{ paddingRight: "8px" }}></i>Mesaj Gruplarım
                        </NavLink>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown style={{ marginLeft: "48px" }}>
                    <Dropdown.Toggle variant="sm" id="dropdown-basic" style={{ border: "none" }}>
                      <i className="bi bi-person" style={{ fontSize: '28px', position: 'absolute', left: "-24px", top: "-6px", color: "navy" }}></i>
                      <label style={{ fontSize: '0.9rem', fontWeight: '500', color: "navy", cursor: "pointer", position:"relative", top:"-2px" }}>{data ? data.adSoyad : ''}</label>
                      <i className="bi bi-chevron-down" style={{ marginLeft: "4px", fontSize: "1rem", position:"relative", top:"-2px" }}></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <NavLink to="/Ayar/Profil">
                          <i className="bi bi-person" style={{ paddingRight: "8px" }}></i>Profilim
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <NavLink to="/Ayar/ChangePassword">
                          <i className="bi bi-key" style={{ paddingRight: "8px" }}></i>Şifre Değiştir
                        </NavLink>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={() => Logout()}>
                        <i className="bi bi-box-arrow-right text-danger" style={{ paddingRight: "8px" }}></i>Güvenli Çıkış
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </nav>

              </header>

              <aside id="sidebar" className="sidebar">
                <Accordion defaultActiveKey="0" className="sidebar-nav" style={{ "--bs-accordion-btn-icon-width": "0.9rem", "--bs-accordion-btn-padding-x": "0.9rem", "--bs-accordion-btn-padding-y": "0.8rem" }}>
                  {
                    data ?
                      data.menuBasliklar && data.menuBasliklar.length > 0 ?
                        data.menuBasliklar.map((menuBaslik, index) => {
                          return (
                            <Accordion.Item key={menuBaslik.id} eventKey={index} style={{ border: "none" }}>
                              <Accordion.Header>
                                <div style={{ color: "#012970", fontWeight: "500", fontSize: "0.9rem", fontFamily: "Poppins"/*"'Open Sans', sans-serif"*/ }}>
                                  <i className={menuBaslik.icon} style={{ opacity: "0.6" }}></i><span style={{ paddingLeft: "8px" }}>{menuBaslik.ad}</span>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {
                                  menuBaslik.menuLinkler && menuBaslik.menuLinkler.length > 0 ?
                                    menuBaslik.menuLinkler.map((menuLink, index) => {
                                      return (
                                        <NavLink key={index} className="nav-link collapsed" to={menuLink.link} style={{ fontSize: "0.9rem", fontWeight: "400" }}>
                                          <i className="bi bi-circle" style={{ fontSize: "6px" }}></i><span>{menuLink.ad}</span>
                                        </NavLink>
                                      )
                                    })
                                    :
                                    ''
                                }
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })
                        :
                        ''
                      :
                      ''
                  }
                </Accordion>

              </aside>
              <main id="main" className="main">
                {/* <div className="pagetitle">
                  <h1>{currentPage}</h1>
                  <nav>
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">{currentFolder}</li>
                      <li className="breadcrumb-item active">{currentPage}</li>
                    </ol>
                  </nav>
                </div> */}
                <div>
                  <Routes>
                    <Route path='/home' element={<ProtectedRoute><Home /></ProtectedRoute>} />
                    <Route path='/genel/karekod' element={<ProtectedRoute><Karekod /></ProtectedRoute>} />
                    <Route path='/erp/cari' element={<ProtectedRoute><Cari /></ProtectedRoute>} />
                    <Route path='/erp/malzeme' element={<ProtectedRoute><Malzeme /></ProtectedRoute>} />
                    <Route path='/erp/proje' element={<ProtectedRoute><Proje /></ProtectedRoute>} />
                    <Route path='/ayar/ayar' element={<ProtectedRoute><Ayar /></ProtectedRoute>} />
                    <Route path='/ayar/rol' element={<ProtectedRoute><Rol /></ProtectedRoute>} />
                    <Route path='/ayar/kullanici' element={<ProtectedRoute><Kullanici /></ProtectedRoute>} />
                    <Route path='/ayar/duyuru' element={<ProtectedRoute><Duyuru /></ProtectedRoute>} />
                    <Route path='/ayar/profil' element={<ProtectedRoute><Profil /></ProtectedRoute>} />
                    <Route path='/ayar/changepassword' element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
                    <Route path='/tanim/urungrubu' element={<ProtectedRoute><UrunGrubu /></ProtectedRoute>} />
                    <Route path='/tanim/urunolcusu' element={<ProtectedRoute><UrunOlcusu /></ProtectedRoute>} />
                    <Route path='/tanim/masrafturu' element={<ProtectedRoute><MasrafTuru /></ProtectedRoute>} />
                    <Route path='/tanim/malzemegrubu' element={<ProtectedRoute><MalzemeGrubu /></ProtectedRoute>} />
                    <Route path='/tanimbasic/*' element={<ProtectedRoute><Tanim /></ProtectedRoute>} />
                    <Route path='/mesaj/mesajyaz/*' element={<ProtectedRoute><MesajYaz /></ProtectedRoute>} />
                    <Route path='/mesaj/mesajac/*' element={<ProtectedRoute><MesajAc /></ProtectedRoute>} />
                    <Route path='/mesaj/mesajkutusu/*' element={<ProtectedRoute><MesajKutusu /></ProtectedRoute>} />
                    <Route path='/mesaj/mesajgrubu' element={<ProtectedRoute><MesajGrubu /></ProtectedRoute>} />
                    <Route path="*" element={<ProtectedRoute><Home to="/home" /></ProtectedRoute>} />
                    <Route path='/' element={<Login />} />
                    <Route path='/auth/forgetpassword' element={<ForgetPassword />} />
                    <Route path='/auth/activatepassword' element={<ActivatePassword />} />
                  </Routes>
                </div>
              </main>
              <footer id="footer" className="footer">
                <div className="copyright">
                  &copy; <strong><span>ATGroup</span></strong> 2025
                </div>
              </footer>
              <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
            </div>
        }

      </BrowserRouter>

    </div>
  );
}

export default App;